import { Season } from '../../domain/models/season.model';
import { Action } from '../action.type';

export const RETRIEVE_SEASONS = 'RETRIEVE_SEASONS';
export const RETRIEVE_SEASONS_SUCCESS = 'RETRIEVE_SEASONS_SUCCESS';
export const RETRIEVE_SEASONS_FAILURE = 'RETRIEVE_SEASONS_FAILURE';

export type RetrieveSeasonsPayload = {
  retry: number;
  token: string;
};

export interface RetrieveSeasons extends Action<RetrieveSeasonsPayload> {
  type: typeof RETRIEVE_SEASONS;
  payload: RetrieveSeasonsPayload;
}

export interface RetrieveSeasonsSuccess extends Action<Season[]> {
  type: typeof RETRIEVE_SEASONS_SUCCESS;
  payload: Season[];
}

export interface RetrieveSeasonsFailure extends Action<string> {
  type: typeof RETRIEVE_SEASONS_FAILURE;
  payload: string;
}
